import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform, AlertController  } from 'ionic-angular';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B08PrinterPage } from '../b08-printer/b08-printer';
import { B02RefundPage } from '../b02-refund/b02-refund';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the B02D02RefundListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface solInfo{
  SOL_ID: number;
  SOL_DESC: string;
  QTY: number;
  UNIT_PRICE: number;
  SOL_TOTAL: string;
  TOTAL_TAX: number;
  GRAND_SOL_TOTAL: number;
}

interface soInfo{
  SO_ID: number;
  SO_NO: string;
  CARD: string;
  DATETIME: string;
  TOTAL: number;
  TOTAL_TAX: number;
  GRAND_TOTAL: number;

  SO_STATUS_ID: number;
  STATUS: string;

  USER_ID: number;
  USER_NAME: string;
}

interface paymentInfo{
  PAYMENT_ID: number;
  AMOUNT_TENDER: string;
  PAYMENT_TYPE_ID: string;
  TYPE: string;
  AMOUNT_CHANGE: string;
  CORP_CARD_NO: string;
  CORP_NAME: string;
  WANTOK_GIFT_CARD_NO: string; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  WANTOK_GIFT_CARD:'';  // [CXY:17/08/2020:IL/MPOS/20-03]:Added
}

interface cardInfo{
  CARD_ID: number;
  CORP_ID: string;
  CORP_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b02-d02-refund-list',
  templateUrl: 'b02-d02-refund-list.html',
})
export class B02D02RefundListPage {

  loading: any;
  Status: any;
  solArr: solInfo[] = [];
  solItems: solInfo[] = [];
  soArr: soInfo[] = [];
  soItems: soInfo[] = [];
  SO_ID: any;
  state:any;
  errorMessage: any;
  TOTAL: any;
  TOTAL_TAX: any;
  GRAND_TOTAL: any;
  SO_DATE: any;
  SO_NO: any;
  companyData = { COMPANY:'', LOGO:'', 
                  ADD1:'', ADD2:'', ADD3:'',
                  CONTACT_NO1:'', CONTACT_NO2:'',
                  EMAIL:'',
                }
  refundData =  { Param:'1', SO_ID:'',
                }
  companyInfo: any;
  userInfo: any;
  receiptInfo: any;
  receiptInfo2: any;
  paymentInfo: any;
  paymentInfo2: any;
  thankyouInfo: any;
  // START: [CXY:17/08/2020:IL/MPOS/20-03]:Added
  s_companyInfo: any;
  s_userInfo: any;
  s_receiptInfo: any;
  s_receiptInfo2: any;
  s_paymentInfo: any;
  s_paymentInfo2: any;
  s_thankyouInfo: any;
  // END: [CXY:17/08/2020:IL/MPOS/20-03]:Added
  userId: any;
  userName: any;
  userGrpId: any;
  userBranchId:any;

  paymentArr: paymentInfo[] = [];
  cardArr: cardInfo[] = [];

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController,
              private alertController:AlertController,
              public storage: Storage, public plt: Platform) {
    
    this.SO_ID = this.navParams.get('paramID');    //SO ID
    this.userId = sessionStorage.getItem('userid');
    this.userName = sessionStorage.getItem('username');
    this.userGrpId = sessionStorage.getItem('usergroupid');

    if (this.userGrpId == '1'){             //if system admin
      let tbl = ["SETTING"];
      let column = ["ID"];
      let value = ["1"];

      let tblkey = ["All"];
      let fktbl = ["All"];
      let fkkey = ["All"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      this.serviceapi.readdata(json_data,"SETTING","1","1").then((result) => {
        this.Status = result["Message"];
        if (this.Status == '1'){
          let Records = result["Records"];
          
          this.companyData.COMPANY = Records[0].COMPANY;
          this.companyData.ADD1 = Records[0].ADD1;
          this.companyData.ADD2 = Records[0].ADD2;
          this.companyData.ADD3 = Records[0].ADD3;
          this.companyData.CONTACT_NO1 = Records[0].CONTACT_NO1;
          this.companyData.CONTACT_NO2 = Records[0].CONTACT_NO2;
          this.companyData.EMAIL = Records[0].EMAIL;
        
          console.log(this.companyData);
          this.continueRequest();
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }

      }, (err) => {
        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      });
    }
    else {
      this.userBranchId = sessionStorage.getItem('userbranchid');
      let tbl = ["BRANCH"];
      let column = ["BRANCH_ID"];
      let value = [this.userBranchId];

      let tblkey = ["All"];
      let fktbl = ["All"];
      let fkkey = ["All"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        
        this.Status = result["Message"];
        if (this.Status == '1'){
          let Records = result["Records"];
          
          this.companyData.COMPANY = Records[0].BRANCH_NAME;              //get company info for receipt header
          this.companyData.ADD1 = Records[0].ADDR1;
          this.companyData.ADD2 = Records[0].ADDR2;
          this.companyData.ADD3 = Records[0].ADDR3;
          this.companyData.CONTACT_NO1 = Records[0].CONTACT_NO;
          this.companyData.EMAIL = Records[0].EMAIL;

          this.continueRequest();
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      });
    }
  }

  continueRequest(){

    console.log(this.SO_ID)
    let sortby= "No";
    let sorttype= "No";

    let tbl = ["SOL"];
    let column = ["SO_ID"];
    let value = [this.SO_ID];

    let tblkey = "No";
    let fktbl = "No";
    let fkkey = "No";

    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"SOL","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        let Records = result["Records"];
        this.solArr = Records;
        this.solItems = this.solArr;
      
        console.log(this.solItems);

        let tbl = ["SO"];
        let column = ["SO_ID"];
        let value = [this.SO_ID];

        let tblkey = ["SO_STATUS_ID", "ACTION_BY"];
        let fktbl = ["SO_STATUS", "USER"];
        let fkkey = ["SO_STATUS_ID", "USER_ID"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.serviceapi.readdata(json_data,"SO","1","1").then((result) => {
          
          this.Status = result["Message"];
          if (this.Status == '1'){
            let Records = result["Records"];
            this.soArr = Records;

            this.TOTAL = this.soArr[0].TOTAL;
            this.TOTAL_TAX = this.soArr[0].TOTAL_TAX;
            this.GRAND_TOTAL = this.soArr[0].GRAND_TOTAL;
            this.SO_DATE = this.soArr[0].DATETIME;
            this.SO_NO = this.soArr[0].SO_NO;
            console.log(this.soItems);


            let tbl = ["PAYMENT"];
            let column = ["SO_ID"];
            let value = [this.SO_ID];

            let tblkey = ["PAYMENT_TYPE_ID"];
            let fktbl = ["PAYMENT_TYPE"];
            let fkkey = ["PAYMENT_TYPE_ID"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");
            this.serviceapi.readdata(json_data,"PAYMENT","1","1").then((result) => {
              
              this.Status = result["Message"];
              if (this.Status == '1'){
                let Records = result["Records"];
                this.paymentArr = Records;

                for (let i=0; i<this.paymentArr.length; i++ ) {
                  if (this.paymentArr[i].CORP_CARD_NO != ''){

                    let tbl = ["CARD"];
                    let column = ["CARD_NO"];
                    let value = [this.paymentArr[i].CORP_CARD_NO];

                    let tblkey = ["CORP_ID"];
                    let fktbl = ["CORPORATE"];
                    let fkkey = ["CORP_ID"];

                    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

                    let mydata = Object.assign(jsonitem);
                    let json_data = this.serviceapi.json_readdata(mydata,"1");
                    this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
                      this.loading.dismiss();
                      this.Status = result["Message"];
                      if (this.Status == '1'){
                        let Records = result["Records"];
                        this.cardArr = Records;

                        this.paymentArr[i].CORP_NAME = this.cardArr[0].CORP_NAME;
                        console.log(this.paymentArr[i].CORP_NAME)
                      }
                      else {
                        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                      }

                    }, (err) => {
                      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                      this.loading.dismiss();
                    });
                  }
                }
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }

            }, (err) => {
              this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
              this.loading.dismiss();
            });
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }

        }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02D02RefundListPage');
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });
    this.loading.present();
  }

  doPrint(param) {
    this.companyInfo = '';
    this.receiptInfo = '';

    let company = this.companyData.COMPANY;
    let address = this.companyData.ADD1 + ', '+ this.companyData.ADD2 + ', '+ this.companyData.ADD3;
    let contact = this.companyData.CONTACT_NO1;
    let email = this.companyData.EMAIL;
    let date = this.SO_DATE;
    let username = this.userName;

    let total = this.TOTAL;
    let total_tax = this.TOTAL_TAX;
    let grand_total = this.GRAND_TOTAL;
  
    if(this.plt.is("core"))
    {
      var mywindow = window.open('', 'RECEIPT', 'height=400,width=600');
      mywindow.document.write('<html><head><title></title>');
      /*optional stylesheet*/ //mywindow.document.write('<link rel="stylesheet" href="main.css" type="text/css" />');
      mywindow.document.write('</head><body >');
      mywindow.document.write('<div style="max-width: 500px;margin: auto;text-align:center">');
      mywindow.document.write('<b>'+company+'</b><br>');
      mywindow.document.write(address+'<br>');
      mywindow.document.write('Phone: '+contact+'<br>');
      mywindow.document.write('Email: '+email+'<br>');
      if (param==1){
        mywindow.document.write('<br><b>'+'RECEIPT'+'</b><br>');
      }
      else{
        mywindow.document.write('<br><b>'+'REFUND'+'</b><br>');
      }
      
      mywindow.document.write('<br>Username: '+username+'<br>');
      mywindow.document.write('Date: '+date+'<br>');
      mywindow.document.write('Receipt Number: '+this.SO_NO+'<br>');
     
      mywindow.document.write('<table>');
      mywindow.document.write('<tr><td style="width:250px;text-align:left">'+'Item' + '</td><td style="width:100px;text-align:right">' +'Price'+ '</td><td style="width:100px;text-align:right">'+'Quantity' + '</td><td style="width:100px;text-align:right">' + 'Subtotal' + '</td></tr>');
      let length1 = this.solArr.length;
      for (let i=0; i<length1; i++ ) {
        mywindow.document.write('<tr><td style="width:250px">'+this.solArr[i].SOL_DESC + '</td><td style="width:100px;text-align:right">'+this.solArr[i].UNIT_PRICE + '</td><td style="width:100px;text-align:right">'+this.solArr[i].QTY + '</td><td style="width:100px;text-align:right"> K' + parseFloat(this.solArr[i].SOL_TOTAL).toFixed(2) + '</td></tr>');
      }
      mywindow.document.write('<br><br>');
      
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Subtotal</td><td style="width:100px; text-align:right"> K' +parseFloat(total.toString()).toFixed(2)+'</td></tr>');
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Tax</td><td style="width:100px; text-align:right"> K' +parseFloat(total_tax.toString()).toFixed(2)+'</td></tr>');
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Total</td><td style="width:100px; text-align:right"> K' +parseFloat(grand_total.toString()).toFixed(2)+'</td></tr></table>');
      //mywindow.document.write('Card No : '+this.translistData.CardNo+'<br>Date    : '+arr[0]+'<br>Time    : '+arr[1]+'<br>Trans ID : '+this.transid+'<br>Amount  : K '+ this.translistData.Amount+'<br>Sold By : '+ this.translistData.UserName);
      mywindow.document.write('<br>'+'---------------------------------------------'+'<br><br>');

      mywindow.document.write('<table>');
      let length2 = this.paymentArr.length;
      for (let i=0; i<length2; i++ ) {
        /*let lengthPay = this.paymentTypeArr.length;
        for (let j=0; j< lengthPay; j++){
          if (this.PAYMENT_Array[i].PAYMENT_TYPE_ID == this.paymentTypeArr[j].PAYMENT_TYPE_ID){
            this.PAYMENT_Array[i].TYPE = this.paymentTypeArr[j].TYPE;
          }
        } */
        if (this.paymentArr[i].PAYMENT_TYPE_ID != '3'){
          // START: [CXY:04/07/2020:CR/MPOS/20-01]:Added
          if(this.paymentArr[i].PAYMENT_TYPE_ID == '7') {
            mywindow.document.write('<tr><td style="width:350px">' + this.paymentArr[i].TYPE + ':' + this.paymentArr[i].WANTOK_GIFT_CARD_NO + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
          }
          // END: [CXY:04/07/2020:CR/MPOS/20-01]:Added
          else
            mywindow.document.write('<tr><td style="width:350px">'+this.paymentArr[i].TYPE + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
        }
        else{
          mywindow.document.write('<tr><td style="width:350px">'+this.paymentArr[i].TYPE + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
          mywindow.document.write('<tr><td style="width:350px">'+ 'Card No.: ' +this.paymentArr[i].CORP_CARD_NO + '</td></tr>');
          mywindow.document.write('<tr><td style="width:350px">'+ 'Company: ' +this.paymentArr[i].CORP_NAME + '</td></tr>');
        }

        if (parseFloat(this.paymentArr[i].AMOUNT_CHANGE) > 0){
          mywindow.document.write('<tr><td style="width:350px">'+'Change' + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.paymentArr[i].AMOUNT_CHANGE).toFixed(2) + '</td></tr>');
        }
      }

      mywindow.document.write('</table><br><br><b>------ PLEASE COME AGAIN ------</b><br>');
      mywindow.document.write('<div></body></html>');

      mywindow.print();
      mywindow.close();
    }
    else {
      this.companyInfo = '';
      this.userInfo = '';
      this.receiptInfo = '';
      this.receiptInfo2 = '';
      this.paymentInfo = '';
      this.paymentInfo2 = '';
      this.thankyouInfo = '';
      // START: [CXY:17/08/2020:IL/MPOS/20-03]:Added
      this.s_companyInfo = '';
      this.s_userInfo = '';
      this.s_receiptInfo = '';
      this.s_receiptInfo2 = '';
      this.s_paymentInfo = '';
      this.s_paymentInfo2 = '';
      this.s_thankyouInfo = '';
      // END: [CXY:17/08/2020:IL/MPOS/20-03]:Added
    
      //header
  /*  '\x1b\x61\x01'     center
      '\n'              end of line
      '\x1b\x45\x00'    Bold font OFF
      '\x1b\x45\x01'    Bold font ON
      '\x1b\x4d\x00'    Font type A //normal font
      '\x1b\x4d\x01'    Font type B //small font
      '\x1b\x4d\x02'    Font type C //big font
      '\x1b\x61\x00'    Left justification
      '\x1b\x61\x01'    Centering
      '\x1b\x61\x02'    Right justification
  */

      //print branch info
      this.companyInfo += "\x1b\x21\x00 \x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+"\n";
      // [CXY:17/08/2020:IL/MPOS/20-03]:Added
      this.s_companyInfo += "\x1b\x4d\x01 \x1b\x21\x00 \x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+"\n";

      if (param == 1){
        this.userInfo += "\n \x1b\x21\x20 \x1b\x45\x01" + 'RECEIPT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
        // [CXY:17/08/2020:IL/MPOS/20-03]:Added
        this.s_userInfo += "\n \x1b\x21\x20 \x1b\x45\x01" + 'RECEIPT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
      }
      else{
        this.userInfo += "\n \x1b\x21\x20 \x1b\x45\x01" + 'REFUND' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
        // [CXY:17/08/2020:IL/MPOS/20-03]:Added
        this.s_userInfo += "\n \x1b\x21\x20 \x1b\x45\x01" + 'REFUND' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
      }

      // [CXY:17/08/2020:IL/MPOS/20-07]: Modify font size
      this.userInfo += '\x1b\x4d\x01' + 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+"\n"+this.SO_NO+"\n\n";                   
      this.userInfo += '\x1b\x4d\x00' + '\x1b\x44\x00' + '\x1b\x44\x10\x18\x22\x25\x00'        //set tab position at 32
      // [CXY:17/08/2020:IL/MPOS/20-03]:Added
      this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+"\n"+this.SO_NO+"\n\n"; 

      //print SOL
      this.userInfo += '\x1b\x61\x00' + '   ' + 'Item' + '\x09' + 'Price'+ '\x09' + 'Quantity' + '\x09' + '\x09' + 'Subtotal' + "\n";
      // [CXY:17/08/2020:IL/MPOS/20-03]:Added
      this.s_userInfo += '\x1b\x61\x00' + ' ' + 'Item' + '   ' + 'Price' + '\x09' + 'Quantity' + ' \x09' + 'Subtotal' + "\n";

      let length1 = this.solArr.length;
      for (let i=0; i<length1; i++ ) {
        if (this.receiptInfo.length < 100) {
          this.receiptInfo += '   ' + this.solArr[i].SOL_DESC + '\x09' + this.solArr[i].UNIT_PRICE + '\x09' + this.solArr[i].QTY + '\x09' + "K" + '\x09' + parseFloat(this.solArr[i].SOL_TOTAL).toFixed(2) + "\n";
          // [CXY:17/08/2020:IL/MPOS/20-03]:Added
          this.s_receiptInfo += ' ' + this.solArr[i].SOL_DESC + ' ' + this.solArr[i].UNIT_PRICE + ' \x09' + this.solArr[i].QTY + '\x09' + "K" + parseFloat(this.solArr[i].SOL_TOTAL).toFixed(2) + "\n";
        }
        else {
          this.receiptInfo2 += '   ' + this.solArr[i].SOL_DESC + '\x09' + this.solArr[i].UNIT_PRICE + '\x09' + this.solArr[i].QTY + '\x09' + "K" + '\x09' + parseFloat(this.solArr[i].SOL_TOTAL).toFixed(2) + "\n";
          // [CXY:17/08/2020:IL/MPOS/20-03]:Added
          this.s_receiptInfo2 += ' ' + this.solArr[i].SOL_DESC + ' ' + this.solArr[i].UNIT_PRICE + ' \x09' + this.solArr[i].QTY + '\x09' + "K" + parseFloat(this.solArr[i].SOL_TOTAL).toFixed(2) + "\n";
        }
      }
      
      this.receiptInfo2 +=  "\n" + "   Subtotal:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(total.toString()).toFixed(2) + "\n" +
                            "   Tax:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(total_tax.toString()).toFixed(2) + "\n" +
                            "   Total:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(grand_total.toString()).toFixed(2) + "\n";
      // [CXY:17/08/2020:IL/MPOS/20-03]:Added
      this.s_receiptInfo2 +=  "\n \x09\x09" + "Subtotal" + ' \x09' + " K" + parseFloat(total.toString()).toFixed(2) + "\n" +
                              "\x09\x09" + "     Tax" + ' \x09' +  " K" + parseFloat(total_tax.toString()).toFixed(2) + "\n" +
                              "\x09\x09" + "   Total" + ' \x09' + " K" + parseFloat(grand_total.toString()).toFixed(2) + "\n";

      this.paymentInfo = '\x1b\x61\x01' + "\n"+'--------------------'+"\n";
      this.paymentInfo += '\x1b\x44\x00' + '\x1b\x44\x22\x25\x00';        //set tab position at 32
      // [CXY:17/08/2020:IL/MPOS/20-03]:Added
      this.s_paymentInfo = '\x1b\x61\x01' + "\n"+'--------------------'+"\n";

      //print payment
      let length2 = this.paymentArr.length;
      for (let i=0; i<length2; i++ ) {
        if (this.paymentArr[i].PAYMENT_TYPE_ID != '3'){
          // START: [CXY:04/07/2020:CR/MPOS/20-01]:Added
          if(this.paymentArr[i].PAYMENT_TYPE_ID == '7') {
            if (this.paymentInfo.length < 90) {
              this.paymentInfo += '\x1b\x61\x00' + '   ' + this.paymentArr[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.paymentInfo += ' ' + 'Card No.: ' + this.paymentArr[i].WANTOK_GIFT_CARD + "\n"; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
              // [CXY:17/08/2020:IL/MPOS/20-03]:Added
              this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.paymentArr[i].TYPE + '\x09\x09' + " K" + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.s_paymentInfo += ' ' + 'Card No.: ' + this.paymentArr[i].WANTOK_GIFT_CARD + "\n";;
            }
            else {
              this.paymentInfo2 += '\x1b\x61\x00' + '   ' + this.paymentArr[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.paymentInfo2 += ' ' + 'Card No.: ' + this.paymentArr[i].WANTOK_GIFT_CARD + "\n"; // [CXY:14/06/2020:CR/MPOS/20-01]:Added
              // [CXY:17/08/2020:IL/MPOS/20-03]:Added
              this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.paymentArr[i].TYPE + '\x09\x09' + " K" + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.s_paymentInfo2 += ' ' + 'Card No.: ' + this.paymentArr[i].WANTOK_GIFT_CARD + "\n";;
            }
          }
          // END: [CXY:04/07/2020:CR/MPOS/20-01]:Added
          else {
            if (this.paymentInfo.length < 90) {
              this.paymentInfo += '\x1b\x61\x00' + '   ' + this.paymentArr[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // [CXY:17/08/2020:IL/MPOS/20-03]:Added
              this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.paymentArr[i].TYPE + '\x09\x09' + " K" + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
            }
            else {
              this.paymentInfo2 += '\x1b\x61\x00' + '   ' + this.paymentArr[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // [CXY:17/08/2020:IL/MPOS/20-03]:Added
              this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.paymentArr[i].TYPE + '\x09\x09' + " K" + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
            }
          }
        }
        else {
          if (this.paymentInfo.length < 90) {
            this.paymentInfo += '\x1b\x61\x00' + '   ' + this.paymentArr[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.paymentInfo += '   ' + 'Card No.: ' + this.paymentArr[i].CORP_CARD_NO + "\n";
            this.paymentInfo += '   ' + 'Company: '+ this.paymentArr[i].CORP_NAME + "\n";
            // START: [CXY:17/08/2020:IL/MPOS/20-03]:Added
            this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.paymentArr[i].TYPE + '\x09\x09' + " K" + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.s_paymentInfo += ' ' + 'Card No.: ' + this.paymentArr[i].CORP_CARD_NO + "\n";
            this.s_paymentInfo += ' ' + 'Company: '+ this.paymentArr[i].CORP_NAME + "\n";
            // END: [CXY:17/08/2020:IL/MPOS/20-03]:Added
          }
          else{
            this.paymentInfo2 += '\x1b\x61\x00' + '   ' + this.paymentArr[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.paymentInfo2 += '   ' + 'Card No.: ' + this.paymentArr[i].CORP_CARD_NO + "\n";
            this.paymentInfo2 += '   ' + 'Company: '+ this.paymentArr[i].CORP_NAME + "\n";
            // START: [CXY:17/08/2020:IL/MPOS/20-03]:Added
            this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.paymentArr[i].TYPE + '\x09\x09' + " K" + parseFloat(this.paymentArr[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.s_paymentInfo2 += ' ' + 'Card No.: ' + this.paymentArr[i].CORP_CARD_NO + "\n";
            this.s_paymentInfo2 += ' ' + 'Company: '+ this.paymentArr[i].CORP_NAME + "\n";
            // END: [CXY:17/08/2020:IL/MPOS/20-03]:Added
          }
        } 

        if (parseFloat(this.paymentArr[i].AMOUNT_CHANGE) > 0){
          this.thankyouInfo += '   ' + 'Change' + '\x09' + "K" + '\x09' + parseFloat(this.paymentArr[i].AMOUNT_CHANGE).toFixed(2) + "\n";
          // [CXY:17/08/2020:IL/MPOS/20-03]:Added
          this.s_thankyouInfo += ' ' + 'Change' + '\x09\x09' + " K" + parseFloat(this.paymentArr[i].AMOUNT_CHANGE).toFixed(2) + "\n";
        }
      }

      this.thankyouInfo +=   '\x1b\x61\x01' + "\n\n------ PLEASE COME AGAIN ------\n\n\n\n\n\n\n\n\n\n\n\n\n";
      this.s_thankyouInfo +=   '\x1b\x61\x01' + "\n\n------ PLEASE COME AGAIN ------\n\n\n\n\n\n\n\n\n\n\n\n\n"; 

      this.navCtrl.setRoot(B08PrinterPage,{
        param1: this.companyInfo,
        param2: "3",
        param3: this.userInfo,
        param4: this.receiptInfo,
        param5: this.receiptInfo2,
        param6: this.paymentInfo,
        param7: this.paymentInfo2,
        param8: this.thankyouInfo,
        // START: [CXY:17/08/2020:IL/MPOS/20-03]:Added
        param9: this.s_companyInfo,
        param10: this.s_userInfo,
        param11: this.s_receiptInfo,
        param12: this.s_receiptInfo2,
        param13: this.s_paymentInfo,
        param14: this.s_paymentInfo2,
        param15: this.s_thankyouInfo,
        // END: [CXY:17/08/2020:IL/MPOS/20-03]:Added
      });
    }
  }

  formatDateTime(){
    let date = new Date();
    let sign1 = "-";
    let sign2 = ":";
    let year:any = date.getFullYear() // 年
    let month:any = date.getMonth() + 1; // 月
    let day:any  = date.getDate(); // 日
    let hour:any = date.getHours(); // 时
    let minutes:any = date.getMinutes(); // 分
    let seconds:any = date.getSeconds() //秒

    // 给一位数数据前面加 “0”
    if ((month >= 1) && (month <= 9)) {
      month = '0' + month;
    }
    if ((day >= 0) && (day <= 9)) {
      day = '0' + day;
    }
    if ((hour >= 0) && (hour <= 9)) {
      hour = '0' + hour;
    }
    if ((minutes >= 0) && (minutes <= 9)) {
      minutes = '0' + minutes;
    }
    if ((seconds >= 0) && (seconds <= 9)) {
      seconds = '0' + seconds;
    }
    var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 + seconds;
    return currentdate;
  }

  Refund(){
    let confirm = this.alertController.create({
      title: 'Confirmation',
      message: 'Are you sure you want to perform full refund?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');

            this.refundData.SO_ID = this.SO_ID;
            this.showLoader();
            this.serviceapi.refund(this.refundData).then((result) => {
              this.Status = result["Message"];
              console.log(this.Status);
              if (this.Status == "1"){  
                this.loading.dismiss();
                this.navCtrl.setRoot(B02RefundPage);

                let val = this.GRAND_TOTAL;
                this.storage.get('refundData').then((data) => {
                  if(data != null)
                  {
                    data.push(val);
                    this.storage.set('refundData', data);
                  }
                  else
                  {
                    let array = [];
                    array.push(val);
                    this.storage.set('refundData', array);
                  }
                });
                this.doPrint(2);
              }
              else{
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();

              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
              this.loading.dismiss();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  cancel(){
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02-d02-refund-list/b02-d02-refund-list.ts